<template>
  <div class="container">
    <!-- 主体内容 -->
    <Boyo-Content ref="BoyoContent" :loading="tableDataCusLoading">
      <BoyoButton :buttonList="buttonList"
                  @handClick="handClick">
      </BoyoButton>
      <div style="float:left;margin-bottom:10px;font-size:14px">
        <span>价格本编号：</span>
        <el-input
          size='small'
          style="width:140px"
          v-model="formDate.billNo"
          :disabled="true">
        </el-input>
        <span>价格本标题：</span>
        <el-input
          size='small'
          style="width:140px"
          v-model="formDate.billTitle"
          :disabled="true">
        </el-input>
        <span>客户：</span>
        <el-select size="small" v-model="formDate.partnerId" filterable clearable placeholder="请选择客户" @change="changePartnerId">
          <el-option
            v-for="item in listTypeInfo.partnerId"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <el-table :data="tableInfo2.data"
              border
              max-height="600px"
              style="width: 100%"
              v-loading='tableDataCusLoading'
              :header-cell-style="{background:'#f7f8f9',color:'#3C3C3C',padding:'4px 0',border:'1px solid #e5e7e8' }"
              :cell-style="{padding:'2px'}"
              :span-method="objectSpanMethod"
              @row-click="handleCellChange">
        <el-table-column prop="projectName"
                        label="项目"
                        width="150px" align="center">
        </el-table-column>
        <el-table-column prop="partnerName"
                        label="客户"
                        width="140px" align="center">
        </el-table-column>
        <template v-for="item of tableInfo2.fieldList">
          <el-table-column v-for="(child,index) of item.basePriceAreaList"
                            :key="index"
                            :label="child.label"
                            align="center">
                <el-table-column label="项目价格" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.basePriceAreaList[index].childs[0].partnerAddPrice" :disabled="scope.row.basePriceAreaList[index].disabled">
                    </el-input>
                  </template>
                </el-table-column>
          </el-table-column>
        </template>
      </el-table>
    </Boyo-Content>
  </div>
</template>

<script>
import BoyoContent from '@/components/BoyoContent'
import BoyoButton from '@/components/BoyoButton'
export default {
  name: 'BasicPriceAddCus',
  components: {
    BoyoContent,
    BoyoButton
  },
  props: {},
  data () {
    let nowDate = new Date() 
    var year = nowDate.getFullYear();
    var mother = nowDate.getMonth() > 8 ? (nowDate.getMonth() + 1) : ('0' + (nowDate.getMonth() + 1));
    var day = (nowDate.getDate()) > 9 ? (nowDate.getDate()) : ('0' + (nowDate.getDate()));
    var hour = nowDate.getHours() > 9 ? (nowDate.getHours()) : ('0' + nowDate.getHours());
    var minute = nowDate.getMinutes() > 9 ? (nowDate.getMinutes()) : ('0' + nowDate.getMinutes());
    var second = nowDate.getSeconds() > 9 ? (nowDate.getSeconds()) : ('0' + nowDate.getSeconds());
    var newDay = year + '-' + mother + '-'+ day +' '+ hour + ':' + minute + ':' + second
    var newDay2 = year + '-' + mother + '-'+ day
    return {
      newDay,
      newDay2,
      search: {},
      add2:0,
      MaterialDate:[],//物料数据
      tableDataCus:[],
      tableDataCusLoading:false,//客户价格本加载状态
      addOrUp:false,
      formDate:{
        tissueName:JSON.parse(localStorage.BasicPriceDate).tissueName,
        tissueId:JSON.parse(localStorage.BasicPriceDate).tissueId,
        billNo:JSON.parse(localStorage.BasicPriceDate).billNo,
        billTitle:JSON.parse(localStorage.BasicPriceDate).billTitle,
        billStartTime:JSON.parse(localStorage.BasicPriceDate).billStartTime,
        partnerId:'',//用于批量保存客户价格本
        partnerName:'',
        partnerCode:'',
        saleType:1,
        projectId:'',
        projectCode:'',
        projectName:'',
      },
      // 表格头部按钮相关
      buttonList: {
        // 左按钮
        left: [
          { icon: "el-icon-back", style: "background:#fff;color:#666;border:1px solid #666;margin-right:10px", desc: "返回", event: "back" },
          { icon: "el-icon-refresh-left", style: "background:#fff;color:#666;border:1px solid #666;margin-right:10px", desc: "重置", event: "refresh" },
          { icon: "el-icon-bottom", style: "background:#fff;color:#666;border:1px solid #666;margin-right:10px", desc: "导入最新生效项目价格", event: "addPriceBook" },
          { icon: 'el-icon-edit', style: 'background:#34afbb', desc: '保存客户项目价格本', event: 'create' },
          // { icon: 'el-icon-delete', style: 'background:#e26774', desc: '删除', event: 'delete',show:false },
        ]
      },
      //主体内容是否加载
      listTypeInfo:{
        validStatus:[{value:0,label:'未审核'},{value:1,label:'已审核'}],
        cancleStatus:[{value:0,label:'否'},{value:1,label:'作废'}],
        tissueId:[],
        baseStatus:[{value:0,label:'否'},{value:1,label:'是'}],//是否基价
        bagFlag:[{value:0,label:'散装'},{value:1,label:'袋装'}],//袋装标识
        partnerId:[],//客户
        saleType:[{value:0,label:'区域'},{value:1,label:'项目'}],//销售类型
        projectId:[],//客户项目
        unitName:[],//单位
      },
      //表格相关
      tableInfo2: {
        data: [],//数据
        fieldList: [
          // { value: 'areaName', label: '区域', show: true, dropdown: true },
          { value: 'materialName', label: '客户项目价格本', show: true, dropdown: true,basePriceAreaList:[] },
        ]
      },
    }
  },
  mounted () {
    if (localStorage.loginTissueId) {
      this.listTypeInfo.tissueId = [{value:parseInt(localStorage.loginTissueId),label:localStorage.loginTissueName}]
    } else {
      this.$api.organization.getSysTissuePage({pageNum: 1, pageSize: 999}).then(res => {//组织
          if(res.code == 0) {
              let list3 = res.data.list
              for( let i in list3 ) {
                  this.listTypeInfo.tissueId.push({value: parseInt(list3[i].id), label: list3[i].tissueName})
              }
          }
      })
    }
    this.$api.Customer.getBasePartnerPage({pageNum: 1,pageSize: 999,partnerType:0,forbidStatus:0}).then(res => {//客户
      if (res.code == 0) {
        this.listTypeInfo.partnerId = []
        for(let i in res.data.list){
          this.listTypeInfo.partnerId.push({ value: res.data.list[i].partnerId, label: res.data.list[i].partnerName, partnerCode: res.data.list[i].partnerCode})
        }
      }
    })
    this.$api.Material.getBaseMaterialPage({pageNum: 1,pageSize: 999}).then(res => {//物料
      if (res.code == 0) {
        for(let i in res.data.list){
          if (res.data.list[i].materialType == 1||res.data.list[i].materialType == 2) {
              this.tableInfo2.fieldList[0].basePriceAreaList.push({ value: res.data.list[i].materialId, label: res.data.list[i].materialName,prop:'materialId'+Number(res.data.list[i].materialId)})
              this.MaterialDate.push({ value: res.data.list[i].materialId, label: res.data.list[i].materialName,prop:'materialId'+Number(res.data.list[i].materialId)
              ,basePriceAreaList:[{partnerAddPrice:''}],materialId: res.data.list[i].materialId,materialNo: res.data.list[i].materialNo,materialName: res.data.list[i].materialName,taxRate:res.data.list[i].taxRate
              ,materialSpec:res.data.list[i].materialSpec,baseStatus:Number(res.data.list[i].baseStatus),taxRate:res.data.list[i].taxRate,bagFlag:Number(res.data.list[i].bagFlag),bagSzName:res.data.list[i].bagSzName,bagBzwName:res.data.list[i].bagBzwName,unitName:res.data.list[i].unitName}
            )
          }
        }
      }
    })
    this.getInfo()
  },
  methods: {
    handleCellChange (row, column, event) {
      this.add2 = row.addIndex;
    },
    handleDelete (index, rows) {
      this.tableDataCus.splice(index, 1);
    },
    changePartnerId(val){//选择客户事件
      this.getInfo()
    },
    //搜索事件
    getInfo () {//区域物料表和价格本，没价格本就差区域加价表赋值
      let nowDate = new Date() 
      let year = nowDate.getFullYear();
      let mother = nowDate.getMonth() > 8 ? (nowDate.getMonth() + 1) : ('0' + (nowDate.getMonth() + 1));
      let day = (nowDate.getDate()) > 9 ? (nowDate.getDate()) : ('0' + (nowDate.getDate()));
      let hour = nowDate.getHours() > 9 ? (nowDate.getHours()) : ('0' + nowDate.getHours());
      let minute = nowDate.getMinutes() > 9 ? (nowDate.getMinutes()) : ('0' + nowDate.getMinutes());
      let second = nowDate.getSeconds() > 9 ? (nowDate.getSeconds()) : ('0' + nowDate.getSeconds());
      this.newDay = year + '-' + mother + '-'+ day +' '+ hour + ':' + minute + ':' + second
      // this.newDay2 = year + '-' + mother + '-'+ day
      for (let j of this.MaterialDate) {
        j.basePriceAreaList = []
      }
      this.tableDataCusLoading = true
      this.tableInfo2.data = []
      // this.$api.Region.getBaseAreaPage({pageNum:1,pageSize:999}).then(res => {
      this.$api.Customer.getBasePartnerProjectPage({pageNum:1,pageSize:9999,forbidStatus:0,projectStartTime:this.newDay,projectEndTime:this.newDay,partnerId:this.formDate.partnerId}).then(res => {
        this.tableDataCusLoading = false
        if (res.code == 0) {
          if (res.data.list.length>0) {
            let arr = []
            this.tableDataCus = []
            for (let inq of res.data.list) {
              for (let jd of this.MaterialDate) {
                jd.basePriceAreaList.push({materialId:jd.materialId,materialName:jd.materialName,materialNo:jd.materialNo,materialSpec:jd.materialSpec,baseStatus:Number(jd.baseStatus),partnerAddPrice:'',taxRate:jd.taxRate,bagFlag:Number(jd.bagFlag),bagSzName:jd.bagSzName,bagBzwName:jd.bagBzwName,unitName:jd.unitName})
              }
            }
            // partnerId:jd.partnerId,partnerName:jd.partnerName,
            let arr1 = res.data.list
            this.$api.Material.getBaseMaterialPage({pageNum:1,pageSize:9999}).then(res => {
              if (res.code == 0) {
                let arr2 = res.data.list
                for (let index of arr2) {
                  if (index.materialType == 1||index.materialType == 2) {
                    arr.push(index)
                  }
                }
                let addNum = 0
                for (let index2 of arr1) {
                  this.tableDataCus.push({partnerId:index2.partnerId,partnerName:index2.partnerName,projectName:index2.projectName,projectId:index2.projectId,projectCode:index2.projectCode,addIndex:addNum,basePriceAreaList:[]})
                  for (let index3 of arr) {
                    this.tableDataCus[addNum].basePriceAreaList.push({id:'',partnerId:index2.partnerId,partnerName:index2.partnerName,projectName:index2.projectName,projectId:index2.projectId,projectCode:index2.projectCode,materialId:index3.materialId,materialName:index3.materialName,materialNo:index3.materialNo,materialSpec:index3.materialSpec,baseStatus:Number(index3.baseStatus),partnerAddPrice:'',disabled:true,taxRate:index3
                    .taxRate,unitName:index3.unitName,childs:[
                      {partnerAddPrice:''}
                    ]})
                  }
                  addNum++
                }
                // console.log(this.tableDataCus)
                this.tableInfo2.data = this.tableDataCus
                this.tableDatasCus()
                this.$nextTick(() =>{
                  this.$api.Customer.getBasePricePartnerPage({pageNum:1,pageSize:9999,saleType:1,partnerId:this.formDate.partnerId,priceBookId:JSON.parse(localStorage.BasicPriceDate).priceBookId}).then(res => {
                    // console.log(res.data.list)
                    if (res.data.list.length>0) {
                      this.buttonList.left[3].desc='修改客户项目价格本'
                      this.addOrUp = true//该客户已有相应价格本（拿id走修改）
                      for (let ind of arr1) {
                        for (let inde2 of this.tableInfo2.data) {
                          inde2.basePriceAreaList.forEach((itm1 ,index1)=>{
                            if (ind.materialId == itm1.materialId && ind.partnerId == itm1.partnerId && ind.projectId == itm1.projectId) {
                              itm1.partnerAddPrice = ind.partnerAddPrice
                              itm1.childs[0].partnerAddPrice = ind.partnerAddPrice
                              itm1.disabled = false
                            }
                            for (let inde of res.data.list) {
                              if(inde.basePricePartnerList){
                                for (let ind of inde.basePricePartnerList) {
                                  for (let inde2 of this.tableInfo2.data) {
                                    inde2.basePriceAreaList.forEach((itm1 ,ind1)=>{
                                    // console.log(ind.materialId, itm1.materialId, ind.partnerId, itm1.partnerId,ind.projectId,itm1.projectId)
                                      if (ind.partnerId == itm1.partnerId && ind.materialId == itm1.materialId && ind.projectId == itm1.projectId) {
                                        itm1.id = ind.id
                                        itm1.partnerAddPrice = ind.partnerAddPrice
                                        itm1.childs[0].partnerAddPrice = ind.partnerAddPrice
                                        itm1.disabled = false
                                      }
                                    })
                                  }
                                }
                              }
                            }
                          })
                        }
                      }
                      // for (let inde of res.data.list) {
                      //   if(inde.basePricePartnerList){
                      //     for (let ind of inde.basePricePartnerList) {
                      //       for (let inde2 of this.tableInfo2.data) {
                      //         inde2.basePriceAreaList.forEach((itm1 ,ind1)=>{
                      //         // console.log(ind.materialId, itm1.materialId, ind.partnerId, itm1.partnerId,ind.projectId,itm1.projectId)
                      //           if (ind.partnerId == itm1.partnerId && ind.materialId == itm1.materialId && ind.projectId == itm1.projectId) {
                      //             itm1.id = ind.id
                      //             itm1.partnerAddPrice = ind.partnerAddPrice
                      //             itm1.childs[0].partnerAddPrice = ind.partnerAddPrice
                      //             itm1.disabled = false
                      //           }
                      //         })
                      //       }
                      //     }
                      //   }
                      // }
                    } else {
                      this.buttonList.left[3].desc='保存客户项目价格本'
                      this.addOrUp = false
                      for (let ind of arr1) {
                        // let chongfu = false
                          for (let inde2 of this.tableInfo2.data) {
                            inde2.basePriceAreaList.forEach((itm1 ,index1)=>{
                              // console.log(ind.materialId, itm1.materialId, ind.partnerId, itm1.partnerId,ind.projectId,itm1.projectId)
                              if (ind.materialId == itm1.materialId && ind.partnerId == itm1.partnerId && ind.projectId == itm1.projectId) {
                                itm1.partnerAddPrice = ind.partnerAddPrice
                                itm1.childs[0].partnerAddPrice = ind.partnerAddPrice
                                itm1.disabled = false
                                // chongfu = true
                              }
                            })
                          }
                      }
                    }
                  })
                })
              } else {
                this.$message({ message: res.msg, type: 'error' })
              }
            })
          }
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
      })
    },
    tableDatasCus () {//用于一样的数据列合并
      let _rowspan = 1;
      let _colspan = 1;
      let label = null;
      let row = null;
      this.tableInfo2.data.forEach((item, index) => {
        if (item.partnerId !== label) {
          row = item;
          label = item.partnerId;
          _rowspan = 1;
          _colspan = 1;
          item._rowspan = _rowspan;
          item._colspan = _colspan;
        } else {
          _rowspan++;
          _colspan = 1;
          row._rowspan = _rowspan;
          row._colspan = _colspan;
          item._colspan = 0;
          item._rowspan = 0;
        }
      })
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      //columnIndex == 1合并列
      if (columnIndex == 1) {
        return {
          colspan: row._colspan,
          rowspan: row._rowspan
        }
      }
    },
    // 表格头部按钮相关事件
    handClick (event, data) {
      const dialogInfo = this.dialogInfo
      switch (event) {
        case 'create':
          this.tableDataCusLoading = true
          let arr=[]
          let arr2=[]
          if (!this.addOrUp) {
            for (let ind2 of this.tableInfo2.data) {
              for (let ind of ind2.basePriceAreaList) {
                // ind.partnerId = this.formDate.partnerId
                // ind.partnerName = this.formDate.partnerName
                // ind.partnerCode = this.formDate.partnerCode
                if (ind.projectName && ind.partnerAddPrice) {
                  ind.saleType = this.formDate.saleType
                  ind.priceBookId = JSON.parse(localStorage.BasicPriceDate).priceBookId
                  ind.tissueId = localStorage.loginTissueId
                  ind.tissueName = localStorage.loginTissueName
                  ind.basePrice = ind.childs[0].partnerAddPrice?Number(ind.childs[0].partnerAddPrice):0
                  ind.partnerPrice = ind.childs[0].partnerAddPrice?Number(ind.childs[0].partnerAddPrice):0
                  // ind.projectId = this.formDate.projectId
                  // ind.projectCode = this.formDate.projectCode
                  // ind.projectName = this.formDate.projectName
                  ind.partnerAddPrice=ind.childs[0].partnerAddPrice?Number(ind.childs[0].partnerAddPrice):0
                  arr.push(ind)
                }
              }
            }
            // console.log(arr)
            this.$api.Customer.batchSaveBasePricePartner({basePricePartnerSaveFormList: arr}).then(res => {//客户
              this.tableDataCusLoading = false
              if (res.code === 0) {
                this.$message({ message: res.msg, type: 'success' })
                // dialogInfo.visible = false
                // this.$router.push('/index/system/BasicPrice')
                // this.tableInfo2.data =[]
                this.formDate.partnerId = ''
                this.getInfo()
              } else {
                this.$message({ message: res.msg, type: 'error' })
              }
            })
          }else{
            for (let ind2 of this.tableInfo2.data) {
              for (let ind of ind2.basePriceAreaList) {
                if (ind.id) {
                  arr.push({
                    id:Number(ind.id),
                    saleType:1,
                    partnerAddPrice:ind.childs[0].partnerAddPrice,
                    basePrice:ind.childs[0].partnerAddPrice,
                    partnerPrice:ind.childs[0].partnerAddPrice
                  })
                }else{
                  if (ind.projectName && ind.partnerAddPrice) {
                    ind.saleType = this.formDate.saleType
                    ind.priceBookId = JSON.parse(localStorage.BasicPriceDate).priceBookId
                    ind.tissueId = localStorage.loginTissueId
                    ind.tissueName = localStorage.loginTissueName
                    ind.basePrice = ind.childs[0].partnerAddPrice?Number(ind.childs[0].partnerAddPrice):0
                    ind.partnerPrice = ind.childs[0].partnerAddPrice?Number(ind.childs[0].partnerAddPrice):0
                    ind.partnerAddPrice=ind.childs[0].partnerAddPrice?Number(ind.childs[0].partnerAddPrice):0
                    arr2.push(ind)
                  }
                }
              }
            }
            this.$api.Customer.updateBasePricePartnerBatch({basePricePartnerUpdateFormList: arr}).then(res => {//客户
              this.tableDataCusLoading = false
              if (res.code === 0) {
                this.$message({ message: res.msg, type: 'success' })
                this.getInfo()
              } else {
                this.$message({ message: res.msg, type: 'error' })
              }
            })
            if (arr2.length>0) {
              this.$api.Customer.batchSaveBasePricePartner({basePricePartnerSaveFormList: arr2}).then(res => {//客户
                if (res.code === 0) {
                  // this.$message({ message: res.msg, type: 'success' })
                  this.getInfo()
                } else {
                  this.$message({ message: res.msg, type: 'error' })
                }
              })
            }
          }
          break
        case 'delete':
          let delDataCus = []
          for (let inde of this.tableInfo2.data) {
            // console.log(inde)
            for (let indes of inde.basePriceAreaList) {
              delDataCus.push(indes.id)
            }
          }
          this.$confirm('确认删除该客户记录吗？', '提示', {
            type: 'warning'
          }).then(() => {
            this.$api.Customer.deleteBasePricePartners({ ids: delDataCus }).then(res => {
              if (res.code === 0) {
                this.$message({ message: res.msg, type: 'success' })
                this.tableInfo2.data =[]
                this.formDate.partnerId = ''
              } else {
                this.$message({ message: res.msg, type: 'error' })
              }
            })
          })
          break
        case "back":
          this.$router.push('/index/system/BasicPrice')//返回基础价格本
          break;
        case "refresh":
          this.formDate.projectId = ''
          this.formDate.partnerId = ''
          // this.formDate.saleType = ''
          // this.tableInfo2.data = []
          this.getInfo()
          break
        case "addPriceBook":
          this.tableDataCusLoading = true
          this.$api.Customer.inEffectBasePriceProjecPage({tissueId:localStorage.loginTissueId,pageNum:1,pageSize:999}).then(res => {//客户生效项目价格
            if (res.code == 0) {
              this.basePrice =[]
              this.$message({ message: res.msg, type: 'success' })
              if (res.data.list.length>0) {
                for (let inf of res.data.list) {
                  for (let inde of inf.basePricePartnerList) {
                    this.basePrice.push({projectId:inde.projectId,materialName:inde.materialName,materialId:inde.materialId,basePrice:inde.basePrice})
                    for (let inde1 of this.tableInfo2.data) {
                      for (let inde2 of inde1.basePriceAreaList) {
                        if (inde.projectId == inde2.projectId && inde.materialId == inde2.materialId) {
                          for (const key in inde) {
                            if (key in inde2) {
                              if (key == 'partnerAddPrice') {
                                inde2[key] = inde[key] == 0?'':inde[key]
                                inde2.childs[0].partnerAddPrice = inde[key] == 0?'':inde[key]
                              }
                            }
                          }
                        }
                      }
                    }
                  } 
                }
              }
              this.tableDataCusLoading = false
            } else {
              this.$message({ message: res.msg, type: 'error' })
              this.tableDataCusLoading = false
            }
          })
          break
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>


// WEBPACK FOOTER //
// src/views/pages/System/BasicPriceAddCusPro.vue